/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class JobExecutionDetailsResponse {
    getFixupPrototypeFunction() { return JobExecutionDetailsResponse.fixupPrototype; }

    static newInstance(model: Partial<JobExecutionDetailsResponse>): JobExecutionDetailsResponse {
        let obj = Object.assign(new JobExecutionDetailsResponse(), model);
        JobExecutionDetailsResponse.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<JobExecutionDetailsResponse>): JobExecutionDetailsResponse {
        if (!model) return null;
        return JobExecutionDetailsResponse.newInstance(<JobExecutionDetailsResponse> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: JobExecutionDetailsResponse) {
        if (!obj) return;

        models.JobExecutionDetailsResponse.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: JobExecutionDetailsResponse): boolean {
        Object.setPrototypeOf(obj, JobExecutionDetailsResponse.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        if (this.evaluated_resources_count === undefined) {
            this.evaluated_resources_count = 0;
        }
        if (this.violated_resources_count === undefined) {
            this.violated_resources_count = 0;
        }
        if (typeof this.created_at === "string") {
            this.created_at = new Date(<string><any>this.created_at);
        }
        if (typeof this.updated_at === "string") {
            this.updated_at = new Date(<string><any>this.updated_at);
        }
        if (this.notifications) {
            models.ConfigurationForNotifications.fixupPrototype(this.notifications);
        }
        if (this.cloud_accounts) {
            for (let val of this.cloud_accounts) {
                models.JobServiceAccount.fixupPrototype(val);
            }
        }
        if (this.output) {
            for (let val of this.output) {
                models.JobExecutionOutputDetails.fixupPrototype(val);
            }
        }
    }

    /**
     * Job Id
     */
    job_id: string;

    /**
     * Name of the Job
     */
    name: string;

    /**
     * Status of policy job execution
     */
    status: models.PolicyJobStatus;

    /**
     * Reason for the job status
     */
    status_reason: string;

    /**
     * Whether this policy job has been archived and is excluded from the default (non-archived) job list
     */
    archived: boolean;

    /**
     * Policy engine used for job execution
     */
    engine: string;

    /**
     * arguments provided for job execution
     */
    arguments: any;

    /**
     * Cloud accounts used for job execution
     */
    cloud_accounts: Array<models.JobServiceAccount>;

    /**
     * Policy execution type can be on demand or scheduled
     */
    execution_type: string;

    /**
     * Policy Job created by
     */
    created_by: string;

    /**
     * Policy Job create time in UTC
     */
    created_at: Date;

    /**
     * Policy Job updated by
     */
    updated_by: string;

    /**
     * Policy Job update time in UTC
     */
    updated_at: Date;

    /**
     * Tenant ID
     */
    tenant_id: string;

    /**
     * Policy id of the Policy executed
     */
    policy_id: string;

    /**
     * Number of evaluated resources
     */
    evaluated_resources_count: number;

    /**
     * Number of resources that violated the policy
     */
    violated_resources_count: number;

    /**
     * Job output details
     */
    output: Array<models.JobExecutionOutputDetails>;

    /**
     * Notification configuration that was used for this execution, if any
     */
    notifications: models.ConfigurationForNotifications;

}
